<template>
    <ckeditor
        :modelValue="modelValue"
        :editor="editor.editor"
        :config="editor.editorConfig"
        :disabled="disabled"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
    />
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
    name: "InputTextArea",
    props: {
        modelValue: { required: true },
        disabled: { type: Boolean, default: false },
        checkFocusChange: { type: Boolean, default: false }
    },
    data() {
        return {
            editor: {
                editor: ClassicEditor,
                editorData: '<p>Content of the editor.</p>',
                editorConfig: {
                    toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
                    heading: {
                        options: [
                            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
                        ]
                    }
                }
            },
            isFocused: false
        }
    },
    methods: {
        onInput(val) {
            // External changes should not cause formatting of these changes FAS-2977
            if (this.checkFocusChange && !this.isFocused) return

            this.$emit('update:modelValue', val);
        },
        onFocus() {
            this.isFocused = true;
        },
        onBlur() {
            this.isFocused = false;
        }
    }
}
</script>

<style>
.ck-editor__editable {
    min-height: 300px;
}
</style>
